import { Directive } from '@angular/core';

@Directive({
  selector: '[mbsListSelectGroupCheck]'
})
export class ListSelectGroupCheckDirective {}
